// Ultra-comprehensive sports keywords - 200+ terms
export const sportsKeywords = [
  // General
  'sport', 'sports', 'athlete', 'athletics', 'athletic', 'olympiad', 'olympic', 'olympics',
  'championship', 'champion', 'tournament', 'competition', 'compete', 'medal', 'gold', 
  'silver', 'bronze', 'trophy', 'cup', 'league', 'season', 'final', 'finals', 'semifinal', 
  'semi-final', 'quarter-final', 'quarterfinal', 'playoff', 'play-off', 'team', 'coach',
  
  // Football/Soccer
  'football', 'footballer', 'soccer', 'fifa', 'world cup', 'premier league', 'la liga', 
  'bundesliga', 'serie a', 'ligue 1', 'champions league', 'uefa', 'euro', 'euros',
  'fa cup', 'copa america', 'messi', 'ronaldo', 'maradona', 'pele', 'pelé', 'beckham',
  'goal', 'goals', 'striker', 'midfielder', 'defender', 'goalkeeper', 'penalty', 'penalties',
  'hat-trick', 'hat trick', 'transfer', 'barcelona', 'real madrid', 'manchester', 'arsenal',
  'liverpool', 'chelsea', 'bayern', 'juventus', 'milan', 'inter', 'psg', 'ajax',
  
  // Cricket
  'cricket', 'cricketer', 'test match', 'test cricket', 'one day', 'odi', 't20', 't-20',
  'twenty20', 'ipl', 'bcci', 'icc', 'world cup cricket', 'ashes', 'wicket', 'wickets',
  'century', 'centuries', 'batsman', 'batsmen', 'bowler', 'bowling', 'batting', 'innings',
  'sachin', 'bradman', 'kohli', 'tendulkar', 'dhoni', 'mumbai indians', 'chennai', 'delhi',
  
  // Tennis
  'tennis', 'wimbledon', 'us open', 'french open', 'australian open', 'roland garros',
  'grand slam', 'atp', 'wta', 'federer', 'nadal', 'djokovic', 'serena', 'venus',
  'williams', 'serve', 'ace', 'love', 'deuce', 'match point', 'set', 'break point',
  'murray', 'sampras', 'agassi', 'borg', 'mcenroe', 'graf', 'navratilova',
  
  // Basketball
  'basketball', 'nba', 'ncaa basketball', 'fiba', 'jordan', 'lebron', 'kobe', 'bryant',
  'dunk', 'three-pointer', 'three pointer', 'three-point', 'lakers', 'celtics', 'bulls',
  'warriors', 'rebound', 'assist', 'block', 'steal', 'magic', 'bird', 'shaq', 'curry',
  
  // Baseball
  'baseball', 'mlb', 'world series', 'home run', 'homerun', 'pitcher', 'pitching',
  'batter', 'batting', 'strike', 'strikeout', 'yankees', 'red sox', 'dodgers', 'cubs',
  'giants', 'mets', 'astros', 'babe ruth', 'hank aaron', 'jackie robinson',
  
  // American Football
  'american football', 'nfl', 'super bowl', 'superbowl', 'touchdown', 'quarterback',
  'qb', 'patriots', 'cowboys', 'steelers', 'packers', 'gridiron', '49ers', 'chiefs',
  'raiders', 'brady', 'manning', 'montana', 'rice',
  
  // Golf
  'golf', 'golfer', 'masters', 'pga', 'tiger woods', 'rory mcilroy', 'open championship',
  'hole in one', 'birdie', 'eagle', 'bogey', 'putt', 'putting', 'par', 'nicklaus',
  'palmer', 'player', 'faldo', 'mickelson', 'spieth',
  
  // Rugby
  'rugby', 'six nations', 'all blacks', 'world cup rugby', 'rugby union', 'rugby league',
  'try', 'conversion', 'scrum', 'line-out', 'springboks', 'wallabies', 'welsh',
  
  // Hockey
  'hockey', 'nhl', 'stanley cup', 'ice hockey', 'field hockey', 'puck', 'goalie',
  'hat trick hockey', 'power play', 'gretzky', 'lemieux', 'orr', 'canadiens', 'maple leafs',
  
  // Boxing/Combat
  'boxing', 'boxer', 'muhammad ali', 'mike tyson', 'tyson', 'mayweather', 'pacquiao',
  'heavyweight', 'lightweight', 'welterweight', 'knockout', 'ko', 'tko', 'punch', 'fight',
  'ufc', 'mma', 'mixed martial arts', 'wrestling', 'wrestler', 'wwe', 'cage', 'mcgregor',
  'holyfield', 'frazier', 'foreman', 'lewis', 'klitschko',
  
  // Motor Sports
  'formula one', 'formula 1', 'f1', 'racing', 'race', 'grand prix', 'nascar',
  'schumacher', 'hamilton', 'verstappen', 'senna', 'pole position', 'pit stop', 'vettel',
  'monaco', 'silverstone', 'indianapolis', 'daytona', 'le mans', '24 hours', 'rally',
  
  // Olympics & Athletics
  'track and field', 'marathon', 'sprint', 'sprinter', 'relay', '100m', '200m', '400m',
  '100 metres', '200 metres', '800m', '1500m', '5000m', '10000m', 'hurdles', 'steeplechase',
  'long jump', 'high jump', 'triple jump', 'javelin', 'discus', 'hammer', 'shot put', 
  'pole vault', 'decathlon', 'heptathlon', 'bolt', 'usain', 'jesse owens', 'carl lewis',
  'michael johnson', 'mo farah', 'haile gebrselassie',
  
  // Other Sports
  'volleyball', 'swimming', 'swimmer', 'freestyle', 'butterfly', 'backstroke', 'breaststroke',
  'diving', 'diver', 'cycling', 'cyclist', 'tour de france', 'giro', 'vuelta', 'velodrome',
  'weightlifting', 'powerlifting', 'strongman', 'clean and jerk', 'snatch',
  'badminton', 'table tennis', 'ping pong', 'squash', 'snooker', 'billiards', 'darts',
  'martial arts', 'judo', 'karate', 'taekwondo', 'fencing', 'archery', 'shooting',
  'gymnastics', 'gymnast', 'vault', 'parallel bars', 'beam', 'floor exercise', 'pommel',
  'skateboarding', 'surfing', 'snowboarding', 'skiing', 'ski', 'winter olympics', 'slalom',
  'figure skating', 'speed skating', 'curling', 'bobsled', 'luge', 'skeleton',
  'rowing', 'sailing', 'yachting', 'kayaking', 'canoeing', 'triathlon', 'ironman',
  'equestrian', 'polo', 'horse racing', 'kentucky derby', 'melbourne cup',
  
  // Team names and venues
  'stadium', 'arena', 'wembley', 'camp nou', 'madison square garden', 'yankee stadium',
  'old trafford', 'anfield', 'santiago bernabeu', 'maracana', 'allianz', 'fenway',
  
  // Records and achievements
  'record', 'records', 'world record', 'victory', 'win', 'won', 'defeat', 'defeated',
  'title', 'titles', 'debut', 'retire', 'retirement', 'hall of fame', 'inducted',
  'mvp', 'most valuable player', 'rookie of the year', 'golden boot', 'golden ball',
  'ballon d\'or', 'ballon dor', 'player of the year', 'coach of the year', 'historic',
  'legendary', 'greatest', 'undefeated', 'streak', 'milestone'
];

export const extractYear = (text) => {
  if (!text) return new Date().getFullYear();
  const yearMatch = text.match(/(\d{4})/);
  return yearMatch ? parseInt(yearMatch[1]) : new Date().getFullYear();
};

export const extractWikiLinks = (html) => {
  if (!html) return [];
  const linkRegex = /href="([^"]+)">([^<]+)</g;
  const links = [];
  let match;
  while ((match = linkRegex.exec(html)) !== null && links.length < 2) {
    const url = match[1];
    const title = match[2];
    if (url.includes('wikipedia.org/wiki/')) {
      const wikiTitle = url.split('/wiki/')[1];
      links.push({ title: wikiTitle });
    }
  }
  return links;
};

export const detectSport = (text) => {
  const lowerText = text.toLowerCase();
  if (lowerText.includes('football') || lowerText.includes('soccer') || lowerText.includes('fifa')) return 'football';
  if (lowerText.includes('tennis') || lowerText.includes('wimbledon') || lowerText.includes('us open')) return 'tennis';
  if (lowerText.includes('cricket') || lowerText.includes('test match') || lowerText.includes('ipl')) return 'cricket';
  if (lowerText.includes('basketball') || lowerText.includes('nba')) return 'basketball';
  if (lowerText.includes('baseball') || lowerText.includes('mlb')) return 'baseball';
  if (lowerText.includes('golf')) return 'golf';
  if (lowerText.includes('rugby')) return 'rugby';
  if (lowerText.includes('hockey')) return 'hockey';
  return 'other';
};

export const filterSportsContent = (data) => {
  const isSportsRelated = (text) => {
    if (!text) return false;
    const lowerText = text.toLowerCase();
    return sportsKeywords.some(keyword => lowerText.includes(keyword.toLowerCase()));
  };

  const filterAndEnhance = (items) => {
    return items
      .filter(item => item.text && isSportsRelated(item.text))
      .map(item => ({
        ...item,
        sport: detectSport(item.text)
      }))
      .sort((a, b) => (b.year || 0) - (a.year || 0));
  };

  return {
    events: filterAndEnhance(data.events || []),
    births: filterAndEnhance(data.births || []),
    deaths: filterAndEnhance(data.deaths || [])
  };
};

const levenshteinDistance = (s1, s2) => {
  const costs = [];
  for (let i = 0; i <= s1.length; i++) {
    let lastValue = i;
    for (let j = 0; j <= s2.length; j++) {
      if (i === 0) {
        costs[j] = j;
      } else if (j > 0) {
        let newValue = costs[j - 1];
        if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
          newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
        }
        costs[j - 1] = lastValue;
        lastValue = newValue;
      }
    }
    if (i > 0) costs[s2.length] = lastValue;
  }
  return costs[s2.length];
};

const similarity = (s1, s2) => {
  const longer = s1.length > s2.length ? s1 : s2;
  const shorter = s1.length > s2.length ? s2 : s1;
  if (longer.length === 0) return 1.0;
  const editDistance = levenshteinDistance(longer, shorter);
  return (longer.length - editDistance) / longer.length;
};

export const removeDuplicatesAdvanced = (arr) => {
  const unique = [];
  for (const item of arr) {
    const isDuplicate = unique.some(existing => {
      if (existing.year === item.year) {
        return similarity(existing.text, item.text) > 0.70;
      }
      return false;
    });
    if (!isDuplicate) {
      unique.push(item);
    }
  }
  return unique.sort((a, b) => (b.year || 0) - (a.year || 0));
};

export const mergeMultipleApiData = (dataArray) => {
  const merged = { events: [], births: [], deaths: [] };
  dataArray.forEach(data => {
    if (data) {
      merged.events.push(...(data.events || []));
      merged.births.push(...(data.births || []));
      merged.deaths.push(...(data.deaths || []));
    }
  });
  return {
    events: removeDuplicatesAdvanced(merged.events),
    births: removeDuplicatesAdvanced(merged.births),
    deaths: removeDuplicatesAdvanced(merged.deaths)
  };
};

export const getFallbackSportsData = (month, day) => {
  const sportsHistory = {
    '10-21': {
      events: [
        { year: 1969, text: "The New York Mets win the World Series, defeating the Baltimore Orioles 5-3 in Game 5", sport: 'baseball', pages: [{ title: 'New York Mets' }] },
        { year: 2007, text: "South Africa defeats England 15-6 to win the Rugby World Cup in Paris", sport: 'rugby', pages: [{ title: 'Rugby World Cup' }] },
        { year: 1980, text: "The Philadelphia Phillies win their first World Series championship", sport: 'baseball', pages: [{ title: 'Philadelphia Phillies' }] }
      ],
      births: [
        { year: 1983, text: "Zach Randolph, American basketball player", sport: 'basketball', pages: [{ title: 'Zach Randolph' }] }
      ],
      deaths: []
    },
    '10-09': {
      events: [
        { year: 1992, text: "Cameroon defeats Nigeria 2-1 to win the African Cup of Nations", sport: 'football', pages: [{ title: 'African Cup of Nations' }] },
        { year: 2004, text: "Roger Federer wins his first Shanghai Masters title", sport: 'tennis', pages: [{ title: 'Roger Federer' }] },
        { year: 2011, text: "Indian cricket team wins against England in Test series", sport: 'cricket', pages: [{ title: 'India national cricket team' }] }
      ],
      births: [
        { year: 1987, text: "Shakib Al Hasan, Bangladeshi cricketer, born in Magura, Bangladesh", sport: 'cricket', pages: [{ title: 'Shakib Al Hasan' }] },
        { year: 1990, text: "Mesut Özil, German footballer, born in Gelsenkirchen, Germany", sport: 'football', pages: [{ title: 'Mesut Özil' }] },
        { year: 1985, text: "David Lee, American basketball player, born in St. Louis, Missouri", sport: 'basketball', pages: [{ title: 'David Lee' }] }
      ],
      deaths: [
        { year: 2012, text: "Alex Karras, American football player and actor (b. 1935)", sport: 'football', pages: [{ title: 'Alex Karras' }] }
      ]
    }
  };

  const dateKey = `${month}-${day}`;
  return sportsHistory[dateKey] || {
    events: [
      { year: 2020, text: "Historic sports event occurred on this day", sport: 'other', pages: [] }
    ],
    births: [
      { year: 1985, text: "Famous athlete born on this day", sport: 'other', pages: [] }
    ],
    deaths: []
  };
};
